import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay, Scrollbar, Grid } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay, Scrollbar, Grid]);

const imageSlider = new Swiper('.image-slider-small', {
  slidesPerView: 1,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  breakpoints: {
    550: { slidesPerView: 1.2 },
    1000: { slidesPerView: 2 },
    1400: { slidesPerView: 3 }
  },
  pagination: { el: ".small-image-pagination" },
  navigation: {
    nextEl: ".small-image-swiper-button-next",
    prevEl: ".small-image-swiper-button-prev",
  },
  scrollbar: { el: ".swiper-scrollbar" },
  on: {
    init: function () {
      updateSlideNumbers(this);
    },
    slideChange: function () {
      updateSlideNumbers(this);
    }
  }
});

function updateSlideNumbers(swiper) {
  const current = document.querySelector('.current-slide');
  const total = document.querySelector('.total-slides');
  const realTotal = swiper.slides.length + swiper.loopedSlides - 1;
  if (current) current.textContent = (swiper.realIndex + 1);
  if (total) total.textContent = realTotal;
}
